import "./instrument";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { StateMachineProvider, createStore } from "little-state-machine";
import Auth0ProviderWithHistory from "auth/auth0-provider-with-history";
import { BreakpointProvider } from "react-socks";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { initialState } from "store/store";
import App from "./App";
// disable all react-beautiful-dnd development warnings
window["__react-beautiful-dnd-disable-dev-warnings"] = true;

createStore(initialState);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 5, // 5 seconds
      cacheTime: 1000 * 60 * 60, // 60 minuites
      retry: false,
      retryOnMount: false,
    },
  },
});

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
  <Router>
    <Auth0ProviderWithHistory>
      <QueryClientProvider client={queryClient}>
        <StateMachineProvider>
          <BreakpointProvider>
            <App />
            {/* <ReactQueryDevtools initialIsOpen={false} /> */}
          </BreakpointProvider>
        </StateMachineProvider>
      </QueryClientProvider>
    </Auth0ProviderWithHistory>
  </Router>,
);

[...document.querySelectorAll("style")]
  .filter((el) => el.textContent.trim() === "")
  .forEach((el) => el.parentNode.removeChild(el));

if ("serviceWorker" in navigator && import.meta.env.REACT_APP_ENVIRONMENT_NAME === "qa") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(() => {})
      .catch(() => {});
  });
}
